customElements.define('autogrow-input', class AutogrowInputElement extends HTMLInputElement {

    connectedCallback() { 
        // @link https://stackoverflow.com/a/47644891
        let minWidth = parseInt(getComputedStyle(this).minWidth) || this.clientWidth;
        this.style.overflowX = 'auto'; // 'hidden'

        let fixWidth = event => {
            this.style.width = minWidth + 'px';
            this.style.width = this.scrollWidth + 'px';
        };

        this.addEventListener('input',  fixWidth);
        this.addEventListener('change', fixWidth);

        fixWidth();
    }

}, { extends: 'input' });